





























import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { synthEZDistributeTenGear } from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import LineArea from '../../../_components/charts/LineArea.vue'

  @Component({
    components: {
      BasePanel,
      LineArea
    }
  })
export default class extends Vue {
    @Prop({}) private data!: any
    private mainData: any = {
      others: [],
      details: []
    }
    private colorList: any = []
    private barDataArray: Array < object > = []
    get type() {
      return this.$route.query.type
    }
    created() {
      if (!this.$route.query.searchParams) return
      let params = JSON.parse(this.$route.query.searchParams as string)
      synthEZDistributeTenGear({ ...params, energyZoneType: this.type }).then(res => {
        this.mainData = res.data.synthEZDistributeTenGear
        this.barDataArray = res.data.barChart || []
      })
      // let obj: any = this.data.pie
      // obj.HeightLastTypeIntro = obj.title
      // obj.data = []
      // this.data.pie.dataList.map(v => {
      //   obj.data.push({ name: v.name, value: v.value * 100 })
      // })
      // this.list.push(obj)
      // this.data.staminaHeightPercentVoLine.map(v => {
      //   this.list.push(v)
      // })
    }
}
